import TestRequestResponse from "../api/models/test-request/TestRequestResponse";
import TestPlanResponse from "../api/models/test-series/TestPlanResponse";
import TestRequestApi from "../api/services/TestRequestApi";

type Specification = TestRequestRaw.Schemas.Specification;
type TestPlanVersionIdentifier = TestRequestRaw.Schemas.TestPlanVersionIdentifier;

export default class TestRequestHelper {
  constructor(private testRequestApi: TestRequestApi) {}

  public fetchTestRequest(testRequestId: any): Promise<TestRequestResponse> {
    if (testRequestId) {
      return this.testRequestApi.getTestRequest(testRequestId).then((res) => {
        return res.data;
      });
    }
    return Promise.reject();
  }

  public setAllSamplesReceived(testRequestId: string): Promise<TestRequestResponse> {
    const todayDate = new Date().toISOString().split("T")[0];
    return this.testRequestApi.setAllSamplesReceived(testRequestId, todayDate).then((res) => res.data);
  }

  public addTestSpecification(
    testRequestId: string,
    testSpecId: number,
    testSpecVersion: number,
  ): Promise<TestPlanResponse> {
    return this.testRequestApi
      .addTestPlanToTestRequest(testRequestId, testSpecId, testSpecVersion)
      .then((res) => res.data);
  }

  public addTestSpecifications(testRequestId: string, testSpecifications: Specification[]): Promise<TestPlanResponse> {
    return this.testRequestApi
      .addTestPlansToTestRequest(
        testRequestId,
        testSpecifications.map<TestPlanVersionIdentifier>((ts) => ({
          testPlanId: ts.testPlanVersionId!,
          testPlanVersion: ts.testPlanVersionVersion!,
        })),
      )
      .then((res) => res.data);
  }
}
